import { ApiFragment } from '../../core/records/entities/api-fragment.class';
import { Comparable } from '../../helpers/entities/comparable.interface';
import { Trackable } from '../../helpers/entities/trackable.interface';

interface IHierarchyItem {
    fragment: ApiFragment;
    isCurrent: boolean;
}

export class HierarchyItem implements IHierarchyItem, Comparable, Trackable {
    readonly fragment: ApiFragment;
    readonly isCurrent: boolean;

    constructor({ fragment, isCurrent: currentItem }: IHierarchyItem) {
        this.fragment = fragment;
        this.isCurrent = currentItem;
    }

    equals(other: any): boolean {
        if (!(other instanceof HierarchyItem)) {
            return false;
        }

        return this.fragment.getFragmentId() === other.fragment.getFragmentId();
    }

    trackBy(): string {
        return this.fragment.getFragmentId();
    }
}
